export interface TeaMachinesPollState {
    failureCount: number
    // `kind` of the most recent failed poll's ApiError, when there was one.
    // "config" means a device/integration is mis-configured (bad SmartLab
    // account, integration off) — fast polling cannot fix that, only a person.
    lastErrorKind?: string
}

export const CONFIG_ERROR_POLL_MS = 5 * 60_000

export function teaMachinesRefetchInterval(
    state: TeaMachinesPollState,
    options: { fresh?: boolean } = {},
): number | false {
    // Slow, not stopped: an admin may fix the config at any moment and a
    // wall-mounted kiosk has nobody to press the manual retry button.
    if (state.lastErrorKind === 'config') return CONFIG_ERROR_POLL_MS
    const baseIntervalMs = (options.fresh ?? true) ? 4000 : 8000
    return Math.min(baseIntervalMs * 2 ** state.failureCount, 60_000)
}
